export type OrthoFrustum = {
    left: number;
    right: number;
    top: number;
    bottom: number;
};

/**
 * Orthographic frustum that frames a camera-space box, centered on that box
 * (not on the origin) so edge arrows are not clipped.
 * @param {number} minX - Box min X in camera space
 * @param {number} maxX - Box max X in camera space
 * @param {number} minY - Box min Y in camera space
 * @param {number} maxY - Box max Y in camera space
 * @param {number} exportAspect - Target image width / height
 * @param {number} padding - Extra scale around the box (1.12 = 12%)
 * @return {OrthoFrustum} Camera left/right/top/bottom
 */
export const getOrthoFrustumForBox = (
    minX: number,
    maxX: number,
    minY: number,
    maxY: number,
    exportAspect: number,
    padding = 1.12
): OrthoFrustum => {
    const midX = (minX + maxX) / 2;
    const midY = (minY + maxY) / 2;
    let width = Math.max(maxX - minX, Number.EPSILON) * padding;
    let height = Math.max(maxY - minY, Number.EPSILON) * padding;

    if (width / height > exportAspect) {
        height = width / exportAspect;
    } else {
        width = height * exportAspect;
    }

    return {
        left: midX - width / 2,
        right: midX + width / 2,
        top: midY + height / 2,
        bottom: midY - height / 2,
    };
};
